import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import './Dashboard.css';
import { FaClipboardList, FaPlusSquare, FaNewspaper, FaInfoCircle, FaProjectDiagram, FaSignOutAlt, FaRocket } from 'react-icons/fa';

const Dashboard = () => {
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      navigate('/login');
    } catch (error) {
      console.error('Error signing out: ', error);
    }
  };

  return (
    <div className="dashboard">
      <h1>Welcome to Arab American Consultants!</h1>
      <div className="button-container">
        <Link to="/job-applications" className="widget">
          <FaClipboardList className="icon" />
          <span>View Job Applications</span>
        </Link>
        <Link to="/bim-project" className="widget">
          <FaPlusSquare className="icon" />
          <span>Add BIM Project</span>
        </Link>
        <Link to="/news" className="widget">
          <FaNewspaper className="icon" />
          <span>Add News</span>
        </Link>
        <Link to="/homepage" className="widget">
          <FaNewspaper className="icon" />
          <span>Edit homepage</span>
        </Link>
        <Link to="/about-us" className="widget">
          <FaInfoCircle className="icon" />
          <span>About Us</span>
        </Link>
        <Link to="/project" className="widget">
          <FaProjectDiagram className="icon" />
          <span>Project</span>
        </Link>
        <Link to="/futuristic-admin" className="widget">
          <FaRocket className="icon" />
          <span>Futuristic Projects</span>
        </Link>

        <button className="widget sign-out" onClick={handleSignOut}>
          <FaSignOutAlt className="icon" />
          <span>Sign Out</span>
        </button>
      </div>
    </div>
  );
}

export default Dashboard;